<template>
  <div>
    <vs-table ref="table" :data="students" :noDataText="noDataText">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <vs-collapse style="width: 100%">
          <vs-collapse-item open icon-pack="feather" icon-arrow="icon-arrow-down">
            <div slot="header">
              Filter Students
              <vs-chip color="primary" v-if="numFilters > 0">{{ numFilters }}</vs-chip>
            </div>
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="4"
                vs-sm="6"
                vs-xs="12"
              >
                <vs-input
                  class="w-full mb-base mx-1"
                  label="Search by name or email"
                  v-model="filters.searchstr"
                ></vs-input>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="4"
                vs-sm="6"
                vs-xs="12"
              >
                <select
                  class="defaultselect w-full mb-base mx-1"
                  v-model="filters.class_year"
                  aria-label="Year Group"
                >
                  <option value="">All Graduation Years</option>
                  <option
                    :key="index"
                    :value="item.id"
                    v-for="(item, index) in graduationYears"
                    :selected="filters.class_year == item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="4"
                vs-sm="6"
                vs-xs="12"
              >
                <select
                  class="defaultselect w-full mb-base mx-1"
                  v-model="filters.role"
                  aria-label="Role"
                >
                  <option value="">All Student Roles</option>
                  <option
                    :key="index"
                    :value="item.id"
                    v-for="(item, index) in roles"
                    :selected="filters.role == item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </vs-col>
            </vs-row>
            <button class="btn btn-primary btn-size-medium mx-2" @click="filterStudents">
              Search
            </button>
            <button
              class="btn btn-secondary btn-size-medium mx-2"
              color="success"
              @click="clearFilters"
            >
              Clear
            </button>
          </vs-collapse-item>
        </vs-collapse>
      </div>

      <template slot="thead">
        <vs-th scope="col" width="5%">#</vs-th>
        <vs-th scope="col" sort-key="student_surname" width="21%">Name</vs-th>
        <vs-th scope="col" sort-key="student_email" width="13%">E-mail</vs-th>
        <vs-th scope="col" sort-key="sub_type" width="6%">Student type</vs-th>
        <vs-th scope="col" sort-key="class_year" width="10%">Graduation Year</vs-th>
        <vs-th scope="col" sort-key="num_completed_experiences" width="10%"
          >Completed Experiences</vs-th
        >
        <vs-th scope="col" width="10%">Actions</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ indextr + 1 }}</vs-td>
            <vs-td>{{ tr.student_surname }}, {{ tr.student_name }}</vs-td>
            <vs-td>{{ tr.student_emails }}</vs-td>
            <vs-td>{{ tr.sub_type }}</vs-td>
            <vs-td>{{ tr.class_year }}</vs-td>
            <vs-td>{{ tr.num_completed_experiences }}</vs-td>
            <vs-td class="whitespace-no-wrap">
              <button
                class="btn btn-primary btn-size-small"
                @click="viewExperiences(tr.student_id)"
              >
                View Experiences
              </button>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import router from '@/router/router';
import theApi from '@/mixins/theApi';
import studentMixin from '@/mixins/student';

export default {
  data() {
    return {
      filters: {
        searchstr: '',
        class_year: '',
        role: '',
        status: '',
      },
      student_groups: studentMixin.methods.getGroups(),
      students: [],
      noDataText: `No students have completed any experiences yet. As students do start to complete experiences, the details will appear on this page.`,
    };
  },
  computed: {
    numFilters() {
      let numFilters = 0;
      if (this.filters.searchstr !== '') numFilters++;
      if (this.filters.status !== '') numFilters++;
      if (this.filters.class_year !== '') numFilters++;
      if (this.filters.role !== '') numFilters++;
      return numFilters;
    },
    graduationYears() {
      const startYear = new Date().getFullYear() - 1;
      const lastYear = startYear + 7;

      const years = [];

      for (let year = startYear; year < lastYear; year++) {
        years.push({
          id: year,
          name: `${year} (Year ${13 - (year - startYear)})`,
        });
      }

      return years;
    },
    roles() {
      return [
        { id: 'current', name: 'Current' },
        { id: 'exited', name: 'Exited' },
        { id: 'parent', name: 'Parent' },
        { id: 'other', name: 'Other' },
      ];
    },
  },
  methods: {
    async loadStudents() {
      const formData = new FormData();
      for (const [key, value] of Object.entries(this.filters)) {
        formData.append(key, value);
      }

      theApi.methods.makeCall(false, 'vje_students/all', 'post', formData).then(
        (data) => {
          this.students = data.data;
        },
        () => {},
      );
    },
    viewExperiences(studentID) {
      router.push('/teacher/vje/activity/student/' + studentID);
    },
    filterStudents() {
      this.loadStudents();
    },
    clearFilters() {
      this.filters = {
        searchstr: '',
        class_year: '',
        role: '',
        status: '',
      };
      this.loadStudents();
    },
  },
  mounted() {
    this.loadStudents();
  },
};
</script>

<style lang="scss" scoped>
p.letter-row {
  font-size: 15px;
  padding: 5px;
}
tr.hoverFlat {
  border-bottom: 1px solid #f8f8f8;
}
</style>
